import { isSyncing } from './sync'
import { Notify } from 'quasar'
import { useAuthenticateSAML } from '../store/useAuthenticateSAML'
import { stopAutoSync } from '../composables/useAutoSync'
import { captureException } from '@sentry/vue'

export const syncErrorHandler = (error: any) => {
  isSyncing.value = false
  if (String(error).toLowerCase().includes('sockettimeoutexception')) {
    //alert user of timeout error
    Notify.create({
      type: 'warning',
      timeout: 10000,
      position: 'bottom-left',
      message: 'The sync timed out. Check your connection and try again',
    })
  } else if (String(error).toLowerCase().includes('socketexception')) {
    //alert user of timeout error
    Notify.create({
      type: 'warning',
      timeout: 10000,
      position: 'bottom-left',
      message: 'The sync timed out. Check your connection and try again',
    })
  } else if (String(error).toLowerCase().includes('unknownhostexception')) {
    //alert user of timeout error
    Notify.create({
      type: 'warning',
      timeout: 10000,
      position: 'bottom-left',
      message: 'The sync timed out. Check your connection and try again',
    })
  } else if (String(error).toLowerCase().includes('connectexception')) {
    //alert user of timeout error
    Notify.create({
      type: 'warning',
      timeout: 10000,
      position: 'bottom-left',
      message: 'The sync timed out. Check your connection and try again',
    })
  } else {
    createSyncErrorNotification({ message: `An error occurred: ${error}` })
  }
  console.trace()
  captureException(error)
  return error
}

export const sync200BadFormatHandler = (res: any) => {
  if (res && res.data) {
    if (typeof res.data === 'string') {
      try {
        res.data = JSON.parse(res.data)
      } catch (error) {
        createSyncErrorNotification({ message: 'An error ocurred during data sync.' })
        isSyncing.value = false
        throw new Error(res.data)
      }
    }
  }
}

export const sync401Error = async (res: any) => {
  await checkResponseAuth(res)
}

export const syncBadResponseHandler = (res: any) => {
  isSyncing.value = false

  const is500Error = res.status == 500;
  const errorText = is500Error ? 'A server error occurred' : 'An error occurred during data sync.'

  const refId = res.data && res.data.ref_id ? `. ref_id: ${res.data.ref_id}` : ''

  createSyncErrorNotification({ message: `${errorText}${refId} ` })

  const err = new Error(JSON.stringify(res.data || {}))
  captureException(err)

  throw err
}

//handle unauthorized requests
const checkResponseAuth = async (res: any) => {
  if (res.data.user) {
    if (!res.data.user.authenticated) {
      console.log('no auth')
      isSyncing.value = false
      stopAutoSync()
      const { softLogout } = useAuthenticateSAML()
      await softLogout()
      localStorage.removeItem('saml_request')
      window.location.href = '/#/login'
    }
  }
}

//simple wrapper for now
const createSyncErrorNotification = (data: any) =>
  Notify.create({
    type: 'negative',
    timeout: 0,
    actions: [
      {
        icon: 'close',
        color: 'white',
        // for individual action (button):
        'aria-label': 'Dismiss',
      },
    ],
    position: 'bottom-left',
    message: data.message,
  })

//wrapper for warning
export const createWarningNotification = (data: { message: string }) =>
  Notify.create({
    type: 'warning',
    timeout: 0,
    actions: [
      {
        icon: 'close',
        color: 'black',
        // for individual action (button):
        'aria-label': 'Dismiss',
      },
    ],
    position: 'bottom-left',
    message: data.message,
  })
